var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15005_2001)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15005_2001",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 20,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 11.2496C11.6108 11.2496 12.9166 9.94376 12.9166 8.33293C12.9166 6.72209 11.6108 5.41626 9.99992 5.41626C8.38909 5.41626 7.08325 6.72209 7.08325 8.33293C7.08325 9.94376 8.38909 11.2496 9.99992 11.2496ZM9.99992 9.58293C10.6903 9.58293 11.2499 9.02326 11.2499 8.33293C11.2499 7.64257 10.6903 7.08293 9.99992 7.08293C9.30959 7.08293 8.74992 7.64257 8.74992 8.33293C8.74992 9.02326 9.30959 9.58293 9.99992 9.58293Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3428 17.1133C16.7362 15.6491 18.3334 13.0109 18.3334 9.99959C18.3334 5.39722 14.6024 1.66626 10.0001 1.66626C5.39771 1.66626 1.66675 5.39722 1.66675 9.99959C1.66675 12.0675 2.41999 13.9596 3.66708 15.4163C3.98121 15.7832 4.32667 16.1224 4.69931 16.43C6.1398 17.6188 7.98655 18.3329 10.0001 18.3329C11.5912 18.3329 13.0781 17.887 14.3428 17.1133ZM15.1262 14.2623C16.0882 13.1067 16.6668 11.6207 16.6668 9.99959C16.6668 6.31769 13.682 3.33293 10.0001 3.33293C6.31818 3.33293 3.33342 6.31769 3.33342 9.99959C3.33342 11.6207 3.91203 13.1067 4.87401 14.2623C6.28772 13.1578 8.06703 12.4996 10.0001 12.4996C11.9331 12.4996 13.7124 13.1578 15.1262 14.2623ZM13.8876 15.4161C12.7927 14.6286 11.4508 14.1663 10.0001 14.1663C8.54933 14.1663 7.20749 14.6286 6.11259 15.4161C7.14182 16.1561 8.39058 16.61 9.74242 16.6613C9.82792 16.6646 9.91375 16.6663 10.0001 16.6663C10.1007 16.6663 10.2009 16.664 10.3005 16.6596C11.6359 16.6004 12.8692 16.1483 13.8876 15.4161Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15005_2001)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.000488281,
    width: 20,
    height: 20,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15005_2001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 -0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7cfe52b5baeccdb64dbba812ec96b273.svg";
export { ForwardRef as ReactComponent };